import React from "react";
import dayjs from "dayjs";
import DataTable from "@/components/DataTable";
import { getCMSHistoryTemplateDevicesApi } from "@/apis/apiCollection";
import { useTranslation } from "@/langs/useTranslation";

export const CmsViewDevicesListDatatable = React.forwardRef(
  ({ className, style, templateId, viewType, children, onLoaded }, ref) => {
    const { t } = useTranslation();

    const columns = [
      {
        data: "groupName",
        title: `${t({ defaultMessage: "门店" })}`
      },
      {
        data: "name",
        title: t({ defaultMessage: "设备名称" })
      },
      {
        data: "serialNumber",
        title: t({ defaultMessage: "设备SN" })
      },
      {
        data: "installedAt",
        title: t({ defaultMessage: "安装时间" }),
        render: data => {
          if (!data || data === "0") return "-";
          return dayjs(Number(data)).format("YYYY-MM-DD HH:mm:ss");
        }
      }
    ];

    const ajax = (data, callback, settings) => {
      return getCMSHistoryTemplateDevicesApi({
        contentTemplateHistoryId: templateId,
        // 0待部署 1成功 2失败
        deployStatus:
          viewType === "waitInstallNum"
            ? [0]
            : viewType === "installNum"
            ? [1]
            : [2],
        page: data.page,
        pageSize: data.pageSize
      }).then(res => {
        callback({
          data: res.contentTemplateHistoryDevices,
          draw: data.draw,
          recordsFiltered: res.total,
          recordsTotal: res.total
        });
      });
    };

    return (
      <DataTable
        ref={ref}
        columns={columns}
        ajax={ajax}
        className={className}
        style={style}
        autoLoad
        showCheckAll={false}
        onLoaded={onLoaded}
      >
        {children}
      </DataTable>
    );
  }
);
